"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTENTS_DROP_DEFAULT = exports.CONTENTS_DROP_LIST = exports.CONTENTS_TABS = void 0;
exports.CONTENTS_TABS = [
    { key: 'document', icon: 'document', text: 'supportRoom.documentContents' },
    { key: 'video', icon: 'video', text: 'supportRoom.videoContents' },
    { key: 'background', icon: 'background', text: 'supportRoom.background' },
];
exports.CONTENTS_DROP_LIST = [
    { id: 'all', title: 'common.all' },
    { id: 'document', title: 'supportRoom.documentContents' },
    { id: 'video', title: 'supportRoom.videoContents' },
    { id: 'background', title: 'supportRoom.background' },
];
exports.CONTENTS_DROP_DEFAULT = { id: 'all', title: 'common.all' };
